export default __webpack_public_path__ + "static/media/31.5bd2c64e.jpeg";